import {
  latestPostTypes,
  FetchLatestPostsFailure,
  FetchLatestPostsFailurePayload,
  FetchLatestPostsRequest,
  FetchLatestPostsSuccess,
  FetchLatestPostsSuccessPayload
} from './latestNews.types'

export const latestPostsRequest = (): FetchLatestPostsRequest => ({
  type: latestPostTypes.POST_REQUEST
})

export const latestPostsSuccess = (
  payload: FetchLatestPostsSuccessPayload
): FetchLatestPostsSuccess => ({
  type: latestPostTypes.POST_SUCCESS,
  payload
})

export const latestPostsFailure = (
  payload: FetchLatestPostsFailurePayload
): FetchLatestPostsFailure => ({
  type: latestPostTypes.POST_FAILURE,
  payload
})
